module.exports = __webpack_public_path__ + "img/Pump.3d0f47fe.svg";